import { AccessTime, CheckCircleOutline, EventNote, Key, Person2Outlined } from "@mui/icons-material";

const cardData = [
    {
        Key: 'totalEmployee',
        title: 'Total Employee',
        count: 0,
        icon: <Person2Outlined sx={{ color: '#1976d2' }} /> //blue color
    },

    {
        Key: 'activeUser',
        title: 'Active Now',
        count: 0,
        icon: <CheckCircleOutline sx={{ color: '#2e7d32' }} /> //green color
    },

    {
        Key: 'OnLeave',
        title: ' On Leave',
        count: 0,
        icon: <EventNote sx={{ color: '#d32f2f' }} /> //red color
    },

    {
        Key: 'notStarted',
        title: ' Not Started',
        count: 0,
        icon: <AccessTime sx={{ color: '#ed6c02' }} /> //orange color 
    }


]

export default cardData